module.exports = __webpack_public_path__ + "fonts/AmazonEmber-Regular.af17999.ttf";